import OAuthScopesAddModal_vue_vue_type_script_setup_true_lang_default from "./OAuthScopesAddModal.vue.script.js";
//#region src/v2/blocks/scalar-auth-selector-block/components/OAuthScopesAddModal.vue
var OAuthScopesAddModal_default = OAuthScopesAddModal_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { OAuthScopesAddModal_default as default };

//# sourceMappingURL=OAuthScopesAddModal.vue.js.map